import { Injectable } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class NoDirectAccessGuard {
	private static navigatedFromApp = false;

	constructor(private router: Router) {}

	canActivate: CanActivateFn = (route, state) => {
		const allowAccess = NoDirectAccessGuard.navigatedFromApp;
		NoDirectAccessGuard.navigatedFromApp = false;

		if (!allowAccess) {
			return this.router.parseUrl('');
		}

		return true;
	};

	canActivateChild: CanActivateChildFn = (childRoute, state) => {
		return this.canActivate(childRoute, state);
	};

	public allowNavigation(): void {
		NoDirectAccessGuard.navigatedFromApp = true;
	}
}
